<template>
    <div class="m-b-lg">
        <div v-if="order.statusesByStatusId.id === $status.ASSIGNED_TO_BRANCH.id" class="row">
            <div class="col-lg-12 text-center">
                <button @click="acceptOrder" type="button" class="btn btn-success btn-lg align-middle m-r-lg">Accept</button>
                <button @click="rejectOrder" type="button" class="btn btn-danger btn-lg align-middle">Reject</button>
            </div>
        </div>

        <div v-if="order.statusesByStatusId.id !== $status.ASSIGNED_TO_BRANCH.id && order.orderTypesByOrderTypeId.id === $orderType.TAKE_AWAY.id" class="row">
            <div v-if="order.statusesByStatusId.id === $status.ACCEPTED_BY_BRANCH.id" class="col-lg-12 text-center">
                <button @click="readyForPickup" v-bind:disabled="readyForPickupButton" type="button" class="btn btn-success btn-lg m-l-lg m-r-lg">Ready For Pickup</button>
            </div>
            <div v-if="order.statusesByStatusId.id === $status.READY_FOR_PICKUP.id" class="col-lg-12 text-center">
                <button @click="pickedByCustomer" v-bind:disabled="pickedByCustomerButton" type="button" class="btn btn-success btn-lg m-l-lg m-r-lg">Picked By Customer</button>
            </div>
        </div>
        
        <div v-if="order.statusesByStatusId.id !== $status.ASSIGNED_TO_BRANCH.id && order.orderTypesByOrderTypeId.id === $orderType.DELIVERY.id" class="row">
            <div v-if="order.statusesByStatusId.id === $status.ACCEPTED_BY_BRANCH.id" class="col-lg-12 text-center">
                <button @click="readyForDelivery" type="button" class="btn btn-success btn-lg m-l-lg m-r-lg">Ready For Delivery</button>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 text-center" v-if="order.statusesByStatusId.id === $status.CANCELED.id && order.orderCancellationAcknowledgement === false">
                <button @click="acknowledgeCancelledOrder" type="button" class="btn btn-danger btn-lg m-l-lg m-r-lg">Acknowledge</button>
            </div>
        </div>

        <OrderAcceptModal @acceptOrder="changeOrderStatus" :order="order" />
        <OrderRejectModal @rejectOrder="changeOrderStatus" :order="order" :cancel-reasons="cancelReasons"/>
        <AssignRider @changeOrderStatus="changeOrderStatus" :order="order" :riders="riders" />
    </div>
</template>

<script>
import OrderAcceptModal from "./OrderAcceptModal";
import OrderRejectModal from "./OrderRejectModal";
import AssignRider from "./AssignRider";
export default {
    name: "OrderActions",
    components: {
        OrderAcceptModal,
        OrderRejectModal,
        AssignRider
    },
    data() {
        return {
            timeForOrder: 30,
            readyForPickupButton: false,
            pickedByCustomerButton: false,
        }
    },
    props: {
        order: {
            type: Object,
            required: true
        },
        cancelReasons: {
            type: Array,
            required: true
        },
        riders: {
            type: Array,
            required: true
        },
        sendCancellationNotification: {
          type: Boolean,
          required: false
        }

    },
    methods: {
        acceptOrder() {
            // eslint-disable-next-line no-undef
            $('#branch_order_view_model').animate({ scrollTop: 0 });
            // eslint-disable-next-line no-undef
            $("#order_accept_modal").modal("show");
        },
        rejectOrder() {
            // eslint-disable-next-line no-undef
            $('#branch_order_view_model').animate({ scrollTop: 0 });
            // eslint-disable-next-line no-undef
            $("#order_reject_modal").modal("show");
        },

        //Take Away Function
        async readyForPickup() {
            this.readyForPickupButton = true
            const payload = new URLSearchParams({
                order_id: this.order.id,
                status_id: this.$status.READY_FOR_PICKUP.id
            });
            await this.changeOrderStatus(payload)
            // eslint-disable-next-line no-undef
            $("#branch_order_view_model").modal("hide");
            this.readyForPickupButton = false;
        },
        async pickedByCustomer() {
            this.pickedByCustomerButton = true
            const payload = new URLSearchParams({
                order_id: this.order.id,
                status_id: this.$status.PICKED_BY_CUSTOMER.id
            });
            await this.changeOrderStatus(payload)
            // eslint-disable-next-line no-undef
            $("#branch_order_view_model").modal("hide");
            this.pickedByCustomerButton = false;
        },
        //Take Away Function End
        //Delivery Functions
        readyForDelivery () {
            // eslint-disable-next-line no-undef
            $('#branch_order_view_model').animate({ scrollTop: 0 });
            // eslint-disable-next-line no-undef
            $("#assignRiderModalBranch").modal("show");
        },
        //Delivery Functions End

        async changeOrderStatus(payload) { // Generic Change Order Status Function
            try {
              await this.$http.post(this.$store.state.mainAppURL + "orders/update_order_status", payload.toString());
            } catch (e) {
                // eslint-disable-next-line no-undef
                swal("Error!", e + " Please try again or Contact DVM Tech Support", "error");
                console.error(e)
            }
            this.$emit('updateOrders')
        },
        async acknowledgeCancelledOrder(){
            try {
                await this.$http.get(this.$store.state.mainAppURL + "orders/acknowledge_order_cancellation/" + this.order.id);
                await this.$store.dispatch('stopNotificationBell');
            } catch (e) {
                this.showErrorMessage(e);
                console.log(e)
            }
            this.$emit('updateOrders');
            $("#branch_order_view_model").modal("hide");
        }

    }
}
</script>

<style scoped>

</style>
